import find from 'lodash/find';
import React, { FC, useCallback } from 'react';

import ConditionRow from './ConditionRow';
import {
  QueueItemStatusCondition as QueueItemStatusConditionType,
  QueueItemStatusType,
} from 'src/actions/rules/condition';
import { StyledDropdown } from 'src/presentation/components/pages/rules/shared/StyledComponents';

type QueueItemStatusConditionProps = {
  condition: QueueItemStatusConditionType;
  index: number;
  isReadOnly?: boolean;
  onDelete: Function;
  onUpdate: Function;
};

const QueueItemStatusCondition: FC<QueueItemStatusConditionProps> = ({
  condition,
  index,
  isReadOnly,
  onDelete,
  onUpdate,
}) => {
  const onStatusChange = useCallback(
    val => {
      condition.setValue(val);
      onUpdate({ condition, index });
    },
    [condition, index, onUpdate]
  );

  return (
    <ConditionRow index={index} isReadOnly={isReadOnly} onDelete={onDelete} text="Transfer Status is">
      {isReadOnly ? (
        renderReadOnlyStatus(condition.value)
      ) : (
        <StyledDropdown
          data-aid="queueItemStatusConditionDropdown"
          onSelect={onStatusChange}
          options={statusOptions}
          value={condition.value}
        />
      )}
    </ConditionRow>
  );
};

const statusOptions: { label: string; value: string }[] = [
  { label: 'Initial matching', value: QueueItemStatusType.Queued },
  { label: 'Rematching', value: QueueItemStatusType.Requeued },
];

function renderReadOnlyStatus(value: string) {
  const status = find(statusOptions, { value });
  return <span data-aid="readOnlyQueueItemStatus">{status ? status.label : ''}</span>;
}

export default QueueItemStatusCondition;
